var _rect, _path, _path2, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSslSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158 46",
    role: "img",
    "aria-label": "Secure SSL Encryption",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 46,
    rx: 6,
    fill: "#1B5E20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 7 L47 7 L47 25 Q47 35 37.5 40 Q28 35 28 25 Z",
    fill: "#43A047",
    stroke: "#A5D6A7",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 24 l4 4 l7.5 -9.5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 21,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 800,
    fontSize: 14,
    letterSpacing: 0.5,
    fill: "#FFFFFF"
  }, "SECURE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 35,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 600,
    fontSize: 8.5,
    letterSpacing: 1.5,
    fill: "#C8E6C9"
  }, "SSL ENCRYPTION")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSslSecure);
export default __webpack_public_path__ + "static/media/ssl-secure.04b62d11e4ae9f2bd3bdd27ce56ac9ca.svg";
export { ForwardRef as ReactComponent };